import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { get as _get, isUndefined as _isUndefined, get } from 'lodash-es';
import { of as observableOf, throwError, Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { HttpOptions, RequestParam, ServerResponse } from '../../../connector-studio/interfaces';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  http: HttpClient;
  baseUrl: string;


  constructor(http: HttpClient) {
    this.http = http;
  }


  get(requestParam: RequestParam): Observable<ServerResponse> {
    const httpOptions: HttpOptions = {
      headers: requestParam.header ? requestParam.header : this.getHeader(),
      params: get(requestParam, 'param') || get(requestParam, 'params')
    };

    return this.http.get(requestParam.url, httpOptions).pipe(
      mergeMap((data: ServerResponse) => {
        if (_isUndefined(data)) {
          return throwError(() => new Error(_get(data, 'params.errMsg')));
        }
        return observableOf(data);
      }));
  }

  post(requestParam: RequestParam): Observable<ServerResponse> {
    const httpOptions: HttpOptions = {
      headers: requestParam.header ? this.getHeader(requestParam.header) : this.getHeader(),
      params: requestParam.param
    };
    return this.http.post(requestParam.url, requestParam.data, httpOptions).pipe(
      mergeMap((data: ServerResponse) => {
        if (_isUndefined(data)) {
          return throwError(() => new Error(_get(data, 'params.errMsg')));
        }
        return observableOf(data);
      }));
  }

   patch(requestParam: RequestParam): Observable<ServerResponse> {
    const httpOptions: HttpOptions = {
      headers: requestParam.header ? requestParam.header : this.getHeader(),
      params: requestParam.param
    };
    return this.http.patch(requestParam.url, requestParam.data, httpOptions).pipe(
      mergeMap((data: ServerResponse) => {
        if (_isUndefined(data)) {
          return throwError(() => new Error(_get(data, 'params.errMsg')));
        }
        return observableOf(data);
      }));
  }

  put(requestParam: RequestParam): Observable<ServerResponse> {
    const httpOptions: HttpOptions = {
      headers: requestParam.header ? requestParam.header : this.getHeader(),
      params: requestParam.param
    };
    return this.http.put(requestParam.url, requestParam.data, httpOptions).pipe(
      mergeMap((data: ServerResponse) => {
        if (_isUndefined(data)) {
          return throwError(() => new Error(_get(data, 'params.errMsg')));
        }
        return observableOf(data);
      }));
  }


  // Assuming RequestParam has been adjusted to include responseType and observe options
  downloadFile(requestParam: RequestParam): Observable<HttpResponse<Blob>> {
    const httpOptions = {
      headers: requestParam.header ? requestParam.header : new HttpHeaders(),
      params: requestParam.param ? requestParam.param : new HttpParams(),
      responseType: 'blob' as 'json', // TypeScript hack to allow Blob in response
      observe: 'response' as 'body', // Get the full response
    };
  
    return this.http.post<any>(requestParam.url, requestParam.data,  httpOptions );
  }

  /**
   * for preparing headers
   */
   private getHeader(headers?: HttpOptions['headers']): HttpOptions['headers'] {
    const default_headers = {
      'Accept': 'application/json',
    };
    if (headers) {
      return { ...default_headers, ...headers };
    } else {
      return { ...default_headers };
    }
  }

  delete(requestParam: RequestParam): Observable<ServerResponse> {
    const httpOptions: HttpOptions = {
      headers: requestParam.header ? requestParam.header : this.getHeader(),
      params: requestParam.param
    };
    return this.http.delete(requestParam.url, httpOptions).pipe(
      mergeMap((data: ServerResponse) => {
        if (_isUndefined(data)) {
          return throwError(() => new Error(_get(data, 'params.errMsg')));
        }
        return observableOf(data);
      }));
  }
}
